import React from 'react';

const LoadingSpinner = ({ size = 'medium', message = 'Loading...' }) => {
  const sizeClasses = {
    small: 'w-6 h-6',
    medium: 'w-12 h-12',
    large: 'w-16 h-16'
  };

  const spinnerSize = sizeClasses[size] || sizeClasses.medium;

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <div className="relative">
        {/* Outer spinning ring */}
        <div className={`${spinnerSize} border-4 border-blue-200 rounded-full`}></div>
        <div 
          className={`${spinnerSize} border-4 border-blue-600 border-t-transparent rounded-full absolute top-0 left-0 animate-spin`}
          style={{ animationDuration: '1s' }}
        ></div>
      </div>
      
      {message && (
        <p className="text-gray-600 font-medium animate-pulse">
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
